import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "discussion-header" }
const _hoisted_2 = { class: "discussion-header__title" }
const _hoisted_3 = { class: "discussion-header__info" }
const _hoisted_4 = { class: "a8-12 c12-12" }
const _hoisted_5 = {
  key: 0,
  class: "mb-48"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Project is now complete and further commenting has been disabled. ", -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "mb-48"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CommentsComponent = _resolveComponent("CommentsComponent")
  const _component_CommentFormComponent = _resolveComponent("CommentFormComponent")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString($props.discussion.title), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_3, _toDisplayString($options.discussion_start_date) + "   •   Started by " + _toDisplayString($options.discussion_author), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_CommentsComponent, {
        comments: $options.sorted_comments,
        "comment-type": "discussion"
      }, null, 8 /* PROPS */, ["comments"]),
      ($props.projectComplete)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_CommentFormComponent, {
              ref: "comment-form",
              "discussion-id": $props.discussion.id,
              "no-border": true,
              "comment-type": "discussion",
              onCommentPosted: $options.refreshComments
            }, null, 8 /* PROPS */, ["discussion-id", "onCommentPosted"])
          ]))
    ])
  ], 64 /* STABLE_FRAGMENT */))
}